import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'

// Georgian fonts - must be imported before index.css
import 'alk-rounded-mtav-med/css/alk-rounded-mtav-med.min.css'
import 'alk-rounded-nusx-med/css/alk-rounded-nusx-med.min.css'

import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
